
    <h1 mat-dialog-title>{{data && data.title || 'Please confirm your action'}}</h1>
    <div mat-dialog-content>
      <mat-list class="mat-dialog-data-list">
        <h3 mat-subheader>{{data?.subtitle || 'Are you sure?'}}</h3>
       </mat-list>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end">
	    <button mat-raised-button mat-dialog-close cdkFocusInitial>Cancel</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true">{{data?.confirmButtonText || 'Yes!'}}</button>
    </div>
  